"use strict";

module.exports = require("./BaseAdapter");